var __jsx = React.createElement;
import { useCustomer } from '@lib/context/shared/customer-context';
import useMuscleRouter from '@lib/hooks/use-muscle-router';
import { MuscleButton } from '@modules/shared/components/buttons';
import MuscleDropdown from '@modules/shared/components/dropdown';
import { useTranslations } from 'next-intl';
import React, { useRef } from 'react';
import 'styles/layout/header.css';
import EntityPointsDisplay from '@modules/shared/components/points-quantity-display';
import HideFromBreakpointDiv from '@modules/shared/components/conditional-divs/hide-from-breakpoint-div';
import { MIXPANEL_EVENTS } from '@lib/mixpanel/mixpanel.event-list';
import useTrackEvent from '@lib/hooks/use-track-event';
import Icons from '@modules/icons';
import APP_CONFIGURATION from '@lib/app.config';
import { BREAKPOINTS } from '@lib/constants';
import { useMediaQuery } from 'react-responsive';
import useCssModules from '@lib/hooks/use-css-modules';
import { permissionsManager } from '@lib/permissions/permissions-manager';
const HeaderAccountButton = _ref => {
  let {
    additionalDropdownItems = [],
    dataTestId
  } = _ref;
  const router = useMuscleRouter();
  const t = useTranslations('Shared.Account');
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const headerAccountButtonRef = useRef(null);
  const {
    customerName,
    customerProfilePic,
    customerEmail,
    customerAvailablePoints,
    logout
  } = useCustomer();
  const [isLoggingOut, setIsLoggingOut] = React.useState(false);
  const [accountDropdownIsOpen, setAccountDropdownIsOpen] = React.useState(false);
  const trackEvent = useTrackEvent();
  const {
    cssModules
  } = useCssModules();
  const {
    headerProfilePictureClassNames,
    headerProfilePictureLetterClassNames,
    headerProfileNameClassNames,
    headerProfileIconClassNames,
    headerLogoutButtonClassNames,
    headerLogoutIconButtonClassNames,
    headerDropdownNameClassNames,
    headerDropdownEmailClassNames,
    headerDropdownPointsClassNames,
    headerDropdownItemClassNames,
    headerDropdownItemIconClassNames
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.account.header) || {};
  const onClickEvent = (routerEvent, mixPanelEvent) => {
    trackEvent(mixPanelEvent);
    router.push(routerEvent);
  };
  const onClickLogout = async () => {
    setIsLoggingOut(true);
    await logout();
    setAccountDropdownIsOpen(false);
    setIsLoggingOut(false);
  };
  const renderDropdownButton = (icon, text, onClick) => __jsx("div", {
    className: headerDropdownItemClassNames,
    onClick: () => {
      onClick();
      setAccountDropdownIsOpen(false);
    }
  }, __jsx("div", {
    className: "w-7 flex flex-row items-center justify-center"
  }, icon), text);
  const renderAdditionalButtons = () => {
    return additionalDropdownItems.map((item, index) => item.hiddenInMobile ? __jsx("div", {
      key: "additional-dropdown-item-".concat(index),
      className: "lg:hidden"
    }, renderDropdownButton(item.icon, item.text, () => item.onClick())) : renderDropdownButton(item.icon, item.text, () => item.onClick()));
  };
  const handleAccountButtonClick = () => {
    if (isMobile) {
      router.push('/account');
    } else {
      setAccountDropdownIsOpen(!accountDropdownIsOpen);
    }
  };
  return __jsx("div", null, __jsx("div", {
    className: "header-btn clickable",
    ref: headerAccountButtonRef
  }, __jsx("div", {
    className: headerProfilePictureClassNames,
    style: {
      backgroundImage: customerProfilePic ? "url(\"".concat(customerProfilePic, "\")") : ''
    },
    onClick: () => handleAccountButtonClick()
  }, __jsx("span", {
    className: headerProfilePictureLetterClassNames
  }, customerName ? (customerName || '').charAt(0).toUpperCase() : __jsx(Icons.headerUserIcon, null))), __jsx("div", {
    className: "clickable flex-row items-center gap-1 hidden md:flex text-header-default",
    onClick: () => setAccountDropdownIsOpen(!accountDropdownIsOpen)
  }, __jsx("p", {
    className: headerProfileNameClassNames
  }, customerName), __jsx(Icons.chevronDown, {
    className: headerProfileIconClassNames
  }))), __jsx(MuscleDropdown, {
    alignment: "right",
    buttonRef: headerAccountButtonRef,
    isOpenState: accountDropdownIsOpen,
    setIsOpenState: setAccountDropdownIsOpen
  }, __jsx("div", {
    className: "w-[250px] flex flex-col py-4 bg-white"
  }, __jsx("div", {
    className: "w-full flex flex-col items-center text-neutral-600  border-neutral-600"
  }, __jsx("div", {
    className: headerDropdownNameClassNames
  }, customerName ? "".concat(t('HELLO'), " ").concat(customerName, "!") : "".concat(t('HELLO'), "!")), permissionsManager.showUserEmail() && __jsx("div", {
    className: headerDropdownEmailClassNames
  }, customerEmail), __jsx("div", {
    className: ""
  }, customerAvailablePoints !== undefined && customerAvailablePoints !== null && __jsx(EntityPointsDisplay, {
    quantity: customerAvailablePoints,
    contrastText: false,
    textClassname: headerDropdownPointsClassNames,
    iconClassname: "sm:w-4 sm:h-4",
    useShortPointsName: true
  }))), __jsx(HideFromBreakpointDiv, {
    breakpoint: "md"
  }, __jsx("div", {
    className: "flex flex-col"
  }, renderDropdownButton(__jsx(Icons.person, null), "".concat(t('MY_ACCOUNT')), () => router.push('/account')))), __jsx("div", {
    className: "flex flex-col"
  }, APP_CONFIGURATION.config.profile_sections.show_personal_info && renderDropdownButton(__jsx(Icons.person, {
    className: headerDropdownItemIconClassNames
  }), t('PERSONAL_INFORMATION'), () => {
    onClickEvent('/account?open=personal-information', MIXPANEL_EVENTS.Profile.CLICK_PERSONAL_INFORMATION);
  }), APP_CONFIGURATION.config.profile_sections.show_favorite_passengers && renderDropdownButton(__jsx(Icons.star, {
    className: headerDropdownItemIconClassNames
  }), t('FAVORITE_PASSENGERS'), () => {
    onClickEvent('/account?open=favorite-passengers', MIXPANEL_EVENTS.Profile.CLICK_FAVORITE_PASSENGERS);
  }), APP_CONFIGURATION.config.profile_sections.show_credit_cards && renderDropdownButton(__jsx(Icons.credit_card, {
    className: headerDropdownItemIconClassNames
  }), t('ASSOCIATED_CREDIT_CARDS'), () => {
    onClickEvent('/account?open=credit-cards', MIXPANEL_EVENTS.Profile.CLICK_CARD_INFORMATION);
  }), APP_CONFIGURATION.config.profile_sections.show_bookings && renderDropdownButton(__jsx(Icons.calendar, {
    className: headerDropdownItemIconClassNames
  }), t('MY_BOOKINGS'), () => {
    onClickEvent('/account?open=bookings', MIXPANEL_EVENTS.Profile.CLICK_RESERVATIONS);
  })), additionalDropdownItems.length > 0 ? __jsx(React.Fragment, null, __jsx("div", {
    className: "flex flex-col"
  }, renderAdditionalButtons())) : null, __jsx("div", {
    className: "pt-4 px-4 hover border-t-[0.5px] border-neutral-600  lg:border-0"
  }, __jsx(MuscleButton, {
    variant: "solidXL",
    onClick: onClickLogout,
    disabled: isLoggingOut,
    isLoading: isLoggingOut
  }, __jsx(Icons.circleLogout, {
    className: headerLogoutIconButtonClassNames
  }), t('LOG_OUT'))))));
};
export default HeaderAccountButton;